import { render, staticRenderFns } from "./TraxTrainingRegistrationForceDelete.vue?vue&type=template&id=83d91442"
import script from "./TraxTrainingRegistrationForceDelete.vue?vue&type=script&lang=js"
export * from "./TraxTrainingRegistrationForceDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports